<template>
  <div class="header-grid">
    <div class="container intro-culture">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'headerGrid',
  }
</script>

<style lang="scss" scoped>
.header-grid{
  background-image: url(../../assets/Folded_Paper_background_pattern.jpg);
  background-repeat: no-repeat;
  background-position: center;
  min-height: 500px;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 70);

  @include opacityShow;
  animation-delay: 0.6s;
  opacity: 0;

      h1{
      display: table;
      margin: 0 auto;
      position: relative;
      top:0px;
    }
}
.intro-culture{
  @include opacityShowPosition;
  animation-delay: 1s;
  opacity: 0;
  top: 50%;
  transform: translateY(-50%);  
  
  position: relative;

    h1,p{
      text-align: center;
    }
    p{
      max-width: 670px;
      margin: 0 auto;
    }
    h1{
      margin-bottom: 8px;
    }
    a{
      text-align: center;
      margin: 0 auto;
      display: block;
      margin-top: layout-val-8(4);
    }
}
</style>